import React from 'react';
import Stylesheet from './Modal.module.css';
import Classnames from 'classnames';
import { ico_times } from '../../icon';
import Button from '../../elements/Button/Button';

function Modal(props) {
    const close = () => {
        // aviod content flicking out
        props.onClose(props.icon, props.children, props.title);
    }
    return (
        <div className={Classnames(
            Stylesheet.Container, {
                [Stylesheet['show-container']]: props.show,
                [Stylesheet['hide-container']]: !props.show
            })}>
            <div className={Classnames(
            Stylesheet.Overlay, {
                [Stylesheet['show-overlay']]: props.show,
                [Stylesheet['hide-overlay']]: !props.show
            })} onClick={close}></div>
            <div className={Classnames(
            Stylesheet.Modal, {
                [Stylesheet['show-modal']]: props.show,
                [Stylesheet['hide-modal']]: !props.show
            })}>
                <div className={Stylesheet.Header}>
                    <h5>{props.icon}&emsp;{props.title}</h5>
                    <div className={Stylesheet.Control}>
                        <Button icon onClick={close}>
                            {ico_times}
                        </Button>
                    </div>
                </div>
                <div className={Stylesheet.Container}>
                    {props.content}
                </div>
            </div>
        </div>
    )
}

export default Modal;